import * as Label from "../../../../src/content/project-vars.mdx";
import { Solution, Goal, Achievements } from "../../../../src/components/complete";
import * as React from 'react';
export default {
  Label,
  Solution,
  Goal,
  Achievements,
  React
};